<div class="flex flex-col">
  <label for="household-size" class="text-label text-surface-500">
    Number of people in household
  </label>
  <p-selectButton
    id="household-size"
    class="signup-select-button"
    [unselectable]="false"
    [styleClass]="'w-full h-12'"
    [formControl]="control()"
    [options]="householdSizeOptions"
    optionLabel="label" optionValue="value"/>
</div>
